(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nr-design-system"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.nrHomepage) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const wide = window.matchMedia('(min-width: 800px) and (pointer: fine)');
  const controllers = new Map();
  class RitualSection {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.animations = new Set();
      this.observers = [];
      this.raf = 0;
      this.active = root.dataset.nrMotion !== 'false' && !reduced.matches;
      this.setup();
    }
    listen(target, type, fn, options = {}) {
      target.addEventListener(type, fn, { ...options, signal: this.abort.signal });
    }
    animate(el, frames, options) {
      if (!el.animate) return;
      const animation = el.animate(frames, options);
      this.animations.add(animation);
      animation.finished.then(() => this.animations.delete(animation)).catch(() => {});
    }
    setup() {
      if (this.active && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            observer.unobserve(el);
            this.animate(el, [{ opacity: .12, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 720, easing: 'cubic-bezier(.2,.65,.3,1)' });
          });
        }, { threshold: .08, rootMargin: '0px 0px -18px 0px' });
        this.root.querySelectorAll('[data-nr-reveal]').forEach(el => observer.observe(el));
        this.observers.push(observer);
      }
      const controls = this.root.querySelector('[data-nr-controls]');
      const track = this.root.querySelector('.nr-review-track');
      if (controls && track) {
        const prev = controls.querySelector('[data-nr-prev]');
        const next = controls.querySelector('[data-nr-next]');
        const update = () => {
          prev.disabled = track.scrollLeft < 5;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 5;
        };
        const move = dir => track.scrollBy({ left: dir * ((track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + parseFloat(getComputedStyle(track).gap || 0)), behavior: reduced.matches ? 'instant' : 'smooth' });
        this.listen(prev, 'click', () => move(-1));
        this.listen(next, 'click', () => move(1));
        this.listen(track, 'scroll', update, { passive: true });
        this.listen(track, 'keydown', event => {
          if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        this.listen(window, 'resize', update, { passive: true });
        controls.classList.add('is-ready');
        update();
      }
      const scene = this.root.querySelector('[data-nr-scene]');
      const media = this.root.querySelector('[data-nr-parallax]');
      if (scene && media && this.active && wide.matches) {
        const update = () => {
          this.raf = 0;
          const rect = scene.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > innerHeight) return;
          const progress = Math.max(0, Math.min(1, -rect.top / rect.height));
          media.style.transform = `translate3d(0,${progress * 24}px,0) scale(${1.035 + progress * .045})`;
          const ring = this.root.querySelector('.nr-hero__dial-ring');
          if (ring) ring.style.transform = `rotate(${progress * 100}deg)`;
        };
        this.listen(window, 'scroll', () => { if (!this.raf) this.raf = requestAnimationFrame(update); }, { passive: true });
        update();
      }
      this.root.querySelectorAll('video').forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        const play = () => {
          if (reduced.matches || document.hidden) return video.pause();
          const result = video.play();
          if (result?.catch) result.catch(() => {});
        };
        if (reduced.matches) { video.autoplay = false; video.controls = true; video.pause(); }
        else if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.isIntersecting ? play() : video.pause()), { threshold: .1 });
          observer.observe(video);
          this.observers.push(observer);
        } else play();
        this.listen(document, 'visibilitychange', () => {
          if (document.hidden) video.pause();
          else {
            const rect = video.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < innerHeight) play();
          }
        });
      });
    }
    destroy() {
      this.abort.abort();
      this.observers.forEach(observer => observer.disconnect());
      this.animations.forEach(animation => animation.cancel());
      cancelAnimationFrame(this.raf);
      this.root.querySelectorAll('[data-nr-parallax],.nr-hero__dial-ring').forEach(el => el.style.removeProperty('transform'));
    }
  }
  function mount(scope = document) {
    scope.querySelectorAll('[data-nr-section]').forEach(root => {
      if (!controllers.has(root)) controllers.set(root, new RitualSection(root));
    });
  }
  function refresh() {
    controllers.forEach(controller => controller.destroy());
    controllers.clear();
    mount();
  }
  window.nrHomepage = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, root) => {
      if (event.target.contains(root)) { controller.destroy(); controllers.delete(root); }
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.nr-review-card,.nr-bundle-card,.nr-benefit');
    if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
  });
  reduced.addEventListener('change', refresh);
  wide.addEventListener('change', refresh);
})();
  } catch(e) { console.error(e); }
})();

})();
